<template>
    <div>
        <br>
        <nav v-on:keyup.enter="searchPreOrder" class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline">
                    <input class="form-control mr-sm-2"
                           v-model="search.material_id"
                           type="search"
                           placeholder="รหัส"
                           aria-label="Search"/>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันที่อัพเดต">
                    </date-picker>
                    &nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchPreOrder"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button @click="savePurchaseOrder"
                            class="btn btn-warning my-2 my-sm-0"
                            type="button">
                        <icon name="plus"></icon>
                        สร้าง PO
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">เลือก</th>
                    <th scope="col">รหัส</th>
                    <th scope="col">วันที่สั่งซื้อ</th>
                    <th scope="col">ผู้สั่งซื้อ</th>
                    <th scope="col">ผู้อัพเดตรายการสั่งซื้อ</th>
                    <th scope="col">จำนวนที่สั่งซื้อ</th>
                    <th scope="col">ผู้จำหน่าย</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">หมายเหตุ</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in preOrderList">
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>
                        <input type="checkbox"
                               :value="data"
                               v-model="check"
                               :disabled="data.status==2 || data.vendor == null"
                        />
                    </td>
                    <td>{{ data.material ? data.material.code : '' }}</td>
                    <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                    <td>
                        {{ data.user ? data.user.name : '-' }}
                    </td>
                    <td>
                        {{ data.user_update ? data.user_update.name : '-' }}
                    </td>
                    <td>{{ data.quantity | amount }}</td>
                    <td>
                        <template v-if="data.vendor">
                            {{ data.vendor.name }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>
                        <span v-if="data.status == 1" style="color: red">
                            {{ data.status_name }}
                        </span>
                        <span v-else style="color: #00a699">
                            {{ data.status_name }}
                        </span>
                    </td>
                    <td>
                        <template v-if="data.remark">
                            {{ data.remark }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <a v-if="data.status!=2"
                           @click="showPreOrderModal(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a
                            @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="preOrderList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getPreOrderPage">
            </vue-pagination>
        </div>
        <b-modal
            hide-footer
            ref="import_data"
            id="import"
            title="สั่งซื้อวัตถุดิบ">
            <edit-pre-order-modal @submit="savePreOrderFromModal">
            </edit-pre-order-modal>
        </b-modal>
        <br>
        <b-modal hide-header hide-footer ref="delete_data">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button @click="deletePreOrderList"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideDeleteModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ preOrderList }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import EditPreOrderModal from "./EditPreOrderModal";
import moment from "moment";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'

export default {
    components: {
        VuePagination,
        DatePicker,
        EditPreOrderModal
    },
    name: "pre-order-list",
    data() {
        return {
            check: [],
            dateFormat: 'D MMM YYYY',
            info: {},
            currentDate: "",
            checklist: [],
            delete_id: "",
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.$store.dispatch('PreOrder/setPreOrder');
        this.getCurrentDate();
    },
    computed: {
        ...mapState({
            preOrderList: state => {
                return state.PreOrder.table;
            },
            user: state => {
                return state.Auth.user;
            },
            dataPaginate: state => {
                return state.PreOrder.dataPaginate;
            },
            search: state => {
                return state.PreOrder.search;
            }
        })
    },
    methods: {
        showPreOrderModal(id) {
            //console.log(this.dataPaginate.current_page);
            this.$store.dispatch('PreOrder/show', id);
            this.$refs.import_data.show();
        },
        hidePreOrderModal() {
            this.$refs.import_data.hide();
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_data.show();
        },
        hideDeleteModal() {
            this.$refs.delete_data.hide();
        },
        savePurchaseOrder() {
            let purchase_order = [];
            if (this.check.length > 0) {
                this.check.forEach(select => {
                    select.user_id = parseInt(select.user_id);
                    let info = {
                        id: select.id,
                        material_id: select.material_id,
                        user_id: select.user_id,
                        quantity: select.quantity,
                        price: select.price,
                        discount: 0,
                        discount_status_id: 1,
                        vendor_id: select.vendor_id,
                        date: select.date,
                        status: select.status
                    };
                    purchase_order.push(info);
                });
                let data = {
                    user_id: this.user.id,
                    date: this.currentDate,
                    status: 1,
                    purchase_order: purchase_order
                };
                this.$store.dispatch('PurchaseOrder/createFromClick', data).then(() => {
                    this.goToPurchaseOrderList();
                })
            } else {
                alert('กรุณาเลือกรายการที่ต้องการสร้าง PO')
            }
        },
        getCurrentDate() {
            const currentDate = moment().format("YYYY-MM-DD");
            this.currentDate = currentDate;
        },
        goToPurchaseOrderList() {
            this.$router.push({name: 'purchase-order'})
        },
        savePreOrderFromModal(submitData) {
            if (submitData == 'cancel') {
                this.hidePreOrderModal();
            } else {
                this.$store.dispatch('PreOrder/update', {
                    id: submitData.id,
                    data: submitData
                }).then(() => {
                    this.hidePreOrderModal();
                    this.$store.dispatch('PreOrder/setPreOrder', this.dataPaginate.current_page);
                });
            }
        },
        deletePreOrderList() {
            this.$store.dispatch('PreOrder/delete', this.delete_id).then(() => {
                this.hideDeleteModal();
                this.$store.dispatch('PreOrder/setPreOrder');
            })
        },
        searchPreOrder() {
            this.event_submit = true;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            this.$store.dispatch('PreOrder/search', {
                material_id: this.search.material_id,
                date: this.search.date
            });
        },
        getPreOrderPage() {
            const page = this.dataPaginate.current_page;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            //paginate search
            if (this.event_submit) {
                this.$store.dispatch('PreOrder/search', {
                    page: page,
                    material_id: this.search.material_id,
                    date: this.search.date
                })
            } else {
                //paginate get data
                this.$store.dispatch('PreOrder/setPreOrder', page)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
